// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__QsUrg","row":"NotFound_row__H1rwK","back":"NotFound_back__ZwjSA","image":"NotFound_image__0RnFM"};